queryType